import { Injectable } from '@angular/core';

import { CalendarService } from '../core/services';

@Injectable()
export class WebCalendarService extends CalendarService {
    init() {}
}
